
import React, { useState } from 'react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import GasAIAdvisoryTab from '@/components/gas/analytics/GasAIAdvisoryTab';
import GasConsumptionTab from '@/components/gas/analytics/GasConsumptionTab';
import GasQualityTab from '@/components/gas/analytics/GasQualityTab';
import GasAlarmsTab from '@/components/gas/analytics/GasAlarmsTab';
import GasDeviceDetailsModal from '@/components/gas/analytics/GasDeviceDetailsModal';
import { recentAlarms } from '@/data/gas-analytics-data';
import CompactLayout from '@/components/layout/CompactLayout';

const GasAnalytics = () => {
  const [tab, setTab] = useState("aiAdvisory");
  const [selectedDevice, setSelectedDevice] = useState<null | typeof recentAlarms[0]>(null);
  const [showDeviceModal, setShowDeviceModal] = useState(false);

  const handleDeviceClick = (device: typeof recentAlarms[0]) => {
    setSelectedDevice(device);
    setShowDeviceModal(true);
  };

  const closeDeviceModal = () => {
    setShowDeviceModal(false);
  };

  return (
    <CompactLayout>
      <Tabs defaultValue="aiAdvisory" value={tab} onValueChange={setTab} className="h-full flex flex-col">
        <div className="flex-none overflow-x-auto flex justify-center">
          <TabsList className="bg-white dark:bg-gray-800 p-1 rounded-lg border dark:border-gray-700">
            <TabsTrigger value="aiAdvisory" className="px-3 py-1.5 md:px-4 md:py-2 text-sm">AI Advisory</TabsTrigger>
            <TabsTrigger value="consumption" className="px-3 py-1.5 md:px-4 md:py-2 text-sm">Consumption</TabsTrigger>
            <TabsTrigger value="quality" className="px-3 py-1.5 md:px-4 md:py-2 text-sm">Gas Quality</TabsTrigger>
            <TabsTrigger value="alarms" className="px-3 py-1.5 md:px-4 md:py-2 text-sm">Alarms & Alerts</TabsTrigger>
          </TabsList>
        </div>
        
        <div className="flex-1 overflow-hidden mt-2">
          <TabsContent value="aiAdvisory" className="h-full overflow-auto m-0">
            <GasAIAdvisoryTab />
          </TabsContent>
          
          <TabsContent value="consumption" className="h-full overflow-auto m-0">
            <GasConsumptionTab />
          </TabsContent>
          
          <TabsContent value="quality" className="h-full overflow-auto m-0">
            <GasQualityTab />
          </TabsContent>
          
          <TabsContent value="alarms" className="h-full overflow-auto m-0">
            <GasAlarmsTab onDeviceClick={handleDeviceClick} />
          </TabsContent>
        </div>
      </Tabs>
      
      <GasDeviceDetailsModal 
        isOpen={showDeviceModal}
        onClose={closeDeviceModal}
        device={selectedDevice}
      />
    </CompactLayout>
  );
};

export default GasAnalytics;
